<template>
  <div class="table table-bg treeview search">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>냉장고 리스트</h2>
      </div>
      <!--
      <div v-if="sum" class="strong-text row">
         <span class="title">판매개수:&nbsp;&nbsp;</span><span :class="sum.saleCount > 0 ? 'plus' : (sum.saleCount < 0 ? 'minus': 'zero')">{{ Number(sum.saleCount).toLocaleString() }}</span>
         <span class="title">&nbsp;&nbsp;/&nbsp;&nbsp;판매금액:&nbsp;&nbsp;</span><span :class="sum.saleTotal > 0 ? 'plus' : (sum.saleTotal < 0 ? 'minus': 'zero')">{{ Number(sum.saleTotal).toLocaleString() }}</span>
         <span class="title">&nbsp;&nbsp;/&nbsp;&nbsp;판매이익:&nbsp;&nbsp;</span><span :class="sum.saleProfit > 0 ? 'plus' : (sum.saleProfit < 0 ? 'minus': 'zero')">{{ Number(sum.saleProfit).toLocaleString() }}</span>
         <span class="title">&nbsp;&nbsp;/&nbsp;&nbsp;폐기개수:&nbsp;&nbsp;</span><span :class="sum.discardCount > 0 ? 'plus' : (sum.discardCount < 0 ? 'minus': 'zero')">{{ Number(sum.discardCount).toLocaleString() }}</span>
         <span class="title">&nbsp;&nbsp;/&nbsp;&nbsp;폐기금액:&nbsp;&nbsp;</span><span :class="sum.discardTotal > 0 ? 'plus' : (sum.discardTotal < 0 ? 'minus': 'zero')">{{ Number(sum.discardTotal).toLocaleString() }}</span>
         <span class="title">&nbsp;&nbsp;/&nbsp;&nbsp;기타손실:&nbsp;&nbsp;</span><span :class="sum.etcLoss > 0 ? 'plus' : (sum.etcLoss < 0 ? 'minus': 'zero')">{{ Number(sum.etcLoss).toLocaleString() }}</span>
         <span class="title">&nbsp;&nbsp;/&nbsp;&nbsp;기타수익:&nbsp;&nbsp;</span><span :class="sum.etcProfit > 0 ? 'plus' : (sum.etcProfit < 0 ? 'minus': 'zero')">{{ Number(sum.etcProfit).toLocaleString() }}</span>
         <span class="title">&nbsp;&nbsp;/&nbsp;&nbsp;영업이익:&nbsp;&nbsp;</span><span :class="sum.profit > 0 ? 'plus' : (sum.profit < 0 ? 'minus': 'zero')">{{ Number(sum.profit).toLocaleString() }}</span>
      </div>
      -->
      <div v-if="sum" class="strong-text row">
        <div class="strong-text-header">
         <span class="title wp8">판매개수</span>
         <span class="title wp14">판매금액</span>
         <span class="title wp14">판매이익</span>
         <span class="title wp8">폐기개수</span>
         <span class="title wp14">폐기금액</span>
         <span class="title wp14">기타손실</span>
         <span class="title wp14">기타수익</span>
         <span class="title wp14">영업이익</span>
        </div>
        <div class="strong-text-body">
          <span class="wp8" :class="sum.saleCount > 0 ? 'plus' : (sum.saleCount < 0 ? 'minus': 'zero')">{{ Number(sum.saleCount).toLocaleString() }}</span>
          <span class="wp14" :class="sum.saleTotal > 0 ? 'plus' : (sum.saleTotal < 0 ? 'minus': 'zero')">{{ Number(sum.saleTotal).toLocaleString() }}</span>
          <span class="wp14" :class="sum.saleProfit > 0 ? 'plus' : (sum.saleProfit < 0 ? 'minus': 'zero')">{{ Number(sum.saleProfit).toLocaleString() }}</span>
          <span class="wp8" :class="sum.discardCount > 0 ? 'plus' : (sum.discardCount < 0 ? 'minus': 'zero')">{{ Number(sum.discardCount).toLocaleString() }}</span>
          <span class="wp14" :class="sum.discardTotal > 0 ? 'plus' : (sum.discardTotal < 0 ? 'minus': 'zero')">{{ Number(sum.discardTotal).toLocaleString() }}</span>
          <span class="wp14" :class="sum.etcLoss > 0 ? 'plus' : (sum.etcLoss < 0 ? 'minus': 'zero')">{{ Number(sum.etcLoss).toLocaleString() }}</span>
          <span class="wp14" :class="sum.etcProfit > 0 ? 'plus' : (sum.etcProfit < 0 ? 'minus': 'zero')">{{ Number(sum.etcProfit).toLocaleString() }}</span>
          <span class="wp14" :class="sum.profit > 0 ? 'plus' : (sum.profit < 0 ? 'minus': 'zero')">{{ Number(sum.profit).toLocaleString() }}</span>
        </div>
      </div>
      <div class="table-btn center-right">
        <div class="btn-renew" @click="refreshList">
          <button class="btn btn-40"><span><img src="/static/img/ico-renew@2x.png" alt=""></span></button>
        </div>
        <div class="btn-export-excel" @click="downloadExcel">
          <button class="btn btn-40" :disabled="downloading">
            <span v-if="!downloading"><img src="/static/img/ico_excel@2x.png" alt=""></span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <div @click="downloadAllExcel">
          <button class="btn btn-140">
            <span v-if="!downloading" class="download-all">전체 엑셀 다운로드</span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <table>
        <tr class="header">
          <th>No.</th>
          <th>냉장고 ID</th>
          <th>냉장고 이름</th>
          <th>판매 개수</th>
          <th>판매 금액</th>
          <th>판매 이익</th>
          <th>폐기 개수</th>
          <th>폐기 금액</th>
          <th>기타 손실</th>
          <th>기타 수익</th>
          <th>영업 이익</th>
        </tr>

        <tbody v-if="loading === false && pagination.total > 0">
          <tr v-for="item in list" :key="item.deviceID">
            <td class="text-center">
              <div>{{ item.num }}</div>
            </td>
            <td>
              <div>{{ item.deviceID }}</div>
            </td>
            <td>
              <div>{{ item.deviceName }}</div>
            </td>
            <td>
              <div>{{ Number(item.saleCount).toLocaleString()  }}</div>
            </td>
            <td>
              <div style="color:blue;">{{ Number(item.saleTotal).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.saleProfit).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.discardCount).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.discardTotal).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.etcLoss).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.etcProfit).toLocaleString()  }}</div>
            </td>
            <td>
              <div style="color:red;">{{ Number(item.profit).toLocaleString()  }}</div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="11" class="text-center">{{ loading ? '조회 중입니다.' : '조회 내역이 없습니다.' }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pagination" v-if="pagination.total > 0">
        <span class="pagination-prev" @click="goPrev">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <span v-if="pagination.pageArray[0] > 1" @click="goPage(1)">1</span>
        <span v-if="pagination.pageArray[0] > 1" @click="jumpPrev">...</span>
        <span
          v-for="n in pagination.pageArray"
          :key="n"
          :class="n === pagination.page ? 'page-num current' : 'page-num'"
          @click="goPage(n)"
          >{{ n }}
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="jumpNext"
          >...
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="goPage(pagination.length)"
          >{{ pagination.length }}
        </span>

        <span class="pagination-next" @click="goNext">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <input
          type="number"
          v-model="pagination.input"
          @keyup.enter="goPage(Number(pagination.input))"
        />
      </div>
    </div>
    <!-- <LoadingDiv v-if="loading || downloading"></LoadingDiv> -->
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-continue */
/* eslint-disable no-await-in-loop */

import Configuration from '@/js/Configuration';
import js2excel from 'js2excel'; // https://github.com/dwqs/js2excel
import ButtonLoading from '@/components/include/ButtonLoading';
// import LoadingDiv from '@/components/include/Loading';

export default {
  props: [
    'company',
    'selectEvent',
    'searchCondition', 'searchEvent',
  ],
  components: {
    ButtonLoading,
    // Loading,
  },
  data: () => ({
    list: [],
    pagination: {
      page: 1,
      total: 0,
      length: 1,
      perPage: 10,
      perLength: 5,
      pageArray: [],
      input: 1,
    },
    loading: false,
    downloading: false,
    sum: null,
  }),
  watch: {
    selectEvent() {
      this.pagination.page = 1;
      this.pagination.input = 1;
      this.pagination.total = 0;
      this.pagination.length = 1;
      this.getTotalList(false);
    },
    searchEvent() {
      this.pagination.page = 1;
      this.pagination.input = 1;
      this.pagination.total = 0;
      this.pagination.length = 1;
      this.getTotalList(false);
    },
  },
  created() {
    if (this.company) {
      this.getTotalList(false);
    }
  },
  methods: {
    refreshList() {
      this.getTotalList(false);
    },
    async getTotalList(forDownload) {
      const list = [];
      if (!forDownload) {
        this.list = [];
        this.loading = true;
        await this.getCount();
        await this.getSum();
      }

      let num =
          this.pagination.total -
          (this.pagination.page - 1) * this.pagination.perPage;

      const devices = await this.$searchDevice(this.pagination.page, this.pagination.perPage, this.company.id, '');
      if (devices) {
        for (let i = 0; i < devices.length; i++) {
          const resList = await this.getList(devices[i].deviceID);
          for (let j = 0; j < resList.length; j++) {
            resList[j].num = num;
            list.push(resList[j]);
            num--;
          }
        }
      }

      if (!forDownload) {
        this.list = list;
        this.loading = false;
      }
      return list;
    },
    async getCount() {
      try {
        let countURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/count`;
        if (this.company) {
          countURL += `?companyID=${this.company.id}`;
        }
        const count = await this.$http.get(countURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (count.status !== 200) {
          throw new Error(`Response status is "${count.status}"`);
        }
        if (count.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${count.data.resultCode}"`);
        }
        if (count.data.count < 1) {
          this.pagination.page = 1;
          this.pagination.total = 0;
          this.pagination.length = 1;
          this.$emit('selectDevice', '');
          return this.pagination.total;
        }

        this.pagination.total = count.data.count;
        this.pagination.length = Math.ceil(
          this.pagination.total / this.pagination.perPage,
        );

        const pageBack = Math.floor((this.pagination.perLength - 1) / 2);
        const pageForward = this.pagination.perLength - 1 - pageBack;
        let firstPage = this.pagination.page - pageForward;
        let lastPage = this.pagination.page + pageBack;
        if (firstPage < 1) {
          firstPage = 1;
          lastPage = this.pagination.perLength;
        }
        if (lastPage > this.pagination.length) {
          lastPage = this.pagination.length;
        }
        if (lastPage - firstPage + 1 < this.pagination.perLength) {
          if (firstPage > 1) {
            firstPage -= this.pagination.perLength - lastPage + firstPage - 1;
            if (firstPage < 1) {
              firstPage = 1;
            }
          } else if (lastPage < this.pagination.length) {
            lastPage += this.pagination.perLength - lastPage + firstPage - 1;
            if (lastPage > this.pagination.length) {
              lastPage = this.pagination.length;
            }
          }
        }

        this.pagination.pageArray = [];
        for (let i = firstPage; i <= lastPage; i++) {
          this.pagination.pageArray.push(i);
        }
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.list = [];

        alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
      return this.pagination.total;
    },
    async getList(deviceID) {
      const list = [];

      try {
        let listURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/${deviceID}/tray/product/sales`;
        if (this.searchCondition) {
          listURL += `?${this.searchCondition}`;
        }
        const resList = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (resList.status !== 200) {
          if (resList.status === 204) {
            this.total = 0;
            return list;
          }

          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        const device = resList.data.device;

        await this.getCompanyData(device, 1);

        device.manufactureDate = this.$moment(device.manufactureAt).format('YYYY.MM.DD');
        // device.manufactureTime = this.$moment(device.manufactureAt).format('hh:mm A');
        device.manufactureTime = this.$moment(device.manufactureAt).format('HH:mm:ss');
        device.setupDate = this.$moment(device.setupAt).format('YYYY.MM.DD');
        // device.setupTime = this.$moment(device.setupAt).format('hh:mm A');
        device.setupTime = this.$moment(device.setupAt).format('HH:mm:ss');

        let supplyTotal = 0;
        let profit = 0;
        let saleCount = 0;
        let saleTotal = 0;
        let saleProfit = 0;
        let etcLoss = 0;
        let etcProfit = 0;
        let discardCount = 0;
        let discardTotal = 0;
        let correctRemoveTotal = 0;
        let correctAddTotal = 0;
        let correctAddSoldErrorTotal = 0;
        if (resList.data.device.trays) {
          this.total = resList.data.device.trays.length;
          let num = this.total;

          for (let i = 0; i < resList.data.device.trays.length; i++) {
            const t = resList.data.device.trays[i];
            t.num = num;
            if (t.products && t.products.length > 0) {
              const p = t.products[0];
              t.productID = p.productID;
              t.productName = p.productName;
              t.discardCount = p.discardCount ? p.discardCount : 0;
              t.discardTotal = p.discardTotal ? p.discardTotal : 0;
              t.saleCount = p.saleCount ? p.saleCount : 0;
              t.saleTotal = p.saleTotal ? p.saleTotal : 0;
              t.supplyTotal = p.supplyTotal ? p.supplyTotal : 0;
              t.saleProfit = t.saleTotal - t.supplyTotal;
              //
              t.correctRemoveTotal = p.correctRemoveTotal ? p.correctRemoveTotal : 0;
              t.correctAddTotal = p.correctAddTotal ? p.correctAddTotal : 0;
              t.correctAddSoldErrorTotal = p.correctAddSoldErrorTotal ? p.correctAddSoldErrorTotal : 0;
              //
              t.cancelTotal = p.cancelTotal ? p.cancelTotal : 0;
              t.rebillTotal = p.rebillTotal ? p.rebillTotal : 0;
              t.refundTotal = p.refundTotal ? p.refundTotal : 0;
              t.nonpaymentTotal = p.nonpaymentTotal ? p.nonpaymentTotal : 0;
              t.nonpaymentBillTotal = p.nonpaymentBillTotal ? p.nonpaymentBillTotal : 0;
              //
              // t.profit = t.saleTotal - t.supplyTotal - t.discardTotal - t.cancelTotal + t.rebillTotal - t.refundTotal - t.nonpaymentTotal + t.nonpaymentBillTotal;
              t.etcLoss = t.cancelTotal + t.refundTotal + t.nonpaymentTotal;
              t.etcProfit = t.rebillTotal + t.nonpaymentBillTotal;
              t.profit = t.saleTotal - t.supplyTotal - t.discardTotal - t.etcLoss + t.etcProfit;

              //
              supplyTotal += t.supplyTotal;
              saleCount += t.saleCount;
              saleTotal += t.saleTotal;
              saleProfit += t.saleProfit;
              discardCount += t.discardCount;
              discardTotal += t.discardTotal;
              correctRemoveTotal += t.correctRemoveTotal;
              correctAddTotal += t.correctAddTotal;
              correctAddSoldErrorTotal += t.correctAddSoldErrorTotal;
            }
            t.count = 0;
            num--;
          }

          // profit = saleTotal - supplyTotal - discardTotal - device.cancelTotal + device.rebillTotal - device.refundTotal - device.nonpaymentTotal + device.nonpaymentBillTotal;
          etcLoss = device.cancelTotal + device.refundTotal + device.nonpaymentTotal;
          etcProfit = device.rebillTotal + device.nonpaymentBillTotal;
          profit = saleTotal - supplyTotal - discardTotal - etcLoss + etcProfit;

          device.saleCount = saleCount;
          device.saleTotal = saleTotal;
          device.saleProfit = saleProfit;
          device.etcLoss = etcLoss;
          device.etcProfit = etcProfit;
          device.profit = profit || 0;
          device.discardCount = discardCount;
          device.discardTotal = discardTotal;
          device.correctRemoveTotal = correctRemoveTotal;
          device.correctAddTotal = correctAddTotal;
          device.correctAddSoldErrorTotal = correctAddSoldErrorTotal;
        } else {
          device.saleCount = 0;
          device.saleTotal = 0;
          device.saleProfit = 0;
          device.etcLoss = 0;
          device.etcProfit = 0;
          device.profit = 0;
          device.discardCount = 0;
          device.discardTotal = 0;
          device.correctRemoveTotal = 0;
          device.correctAddTotal = 0;
          device.correctAddSoldErrorTotal = 0;
        }
        list.push(device);
      } catch (e) {
        this.total = 0;
        this.list = [];

        console.error(e);
      }
      return list;
    },
    async getListForExcel(deviceID) {
      const saleList = [];
      try {
        let listURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/${deviceID}/tray/product/sales`;
        if (this.searchCondition) {
          listURL += `?${this.searchCondition}`;
        }
        const resList = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (resList.status !== 200) {
          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        const currentDevice = resList.data.device;

        await this.getCompanyData(currentDevice, 1);
        await this.getCompanyData(currentDevice, 2);

        if (!currentDevice.companyName) return [];

        currentDevice.manufactureDate = this.$moment(currentDevice.manufactureAt).format('YYYY.MM.DD');
        // currentDevice.manufactureTime = this.$moment(currentDevice.manufactureAt).format('hh:mm A');
        currentDevice.manufactureTime = this.$moment(currentDevice.manufactureAt).format('HH:mm:ss');
        currentDevice.setupDate = this.$moment(currentDevice.setupAt).format('YYYY.MM.DD');
        // currentDevice.setupTime = this.$moment(currentDevice.setupAt).format('hh:mm A');
        currentDevice.setupTime = this.$moment(currentDevice.setupAt).format('HH:mm:ss');

        let profit = 0;
        let saleCount = 0;
        let saleTotal = 0;
        let saleProfit = 0;
        let etcLoss = 0;
        let etcProfit = 0;
        let discardCount = 0;
        let discardTotal = 0;
        let correctRemoveTotal = 0;
        let correctAddTotal = 0;
        let correctAddSoldErrorTotal = 0;
        let cancelTotal = 0;
        let rebillTotal = 0;
        let refundTotal = 0;
        let nonpaymentTotal = 0;
        let nonpaymentBillTotal = 0;

        if (currentDevice.trays) {
          this.total = currentDevice.trays.length;

          for (let i = 0; i < currentDevice.trays.length; i++) {
            const t = currentDevice.trays[i];
            if (t.products && t.products.length > 0) {
              const it = t.products[0];

              it.etcLoss = it.cancelTotal + it.refundTotal + it.nonpaymentTotal;
              it.etcProfit = it.rebillTotal + it.nonpaymentBillTotal;
              it.profit = it.saleTotal - it.supplyTotal - it.discardTotal - it.etcLoss + it.etcProfit;

              const c = {
                사업자명: currentDevice.companyName,
                사업자번호: currentDevice.registrationNo,
                운영자명: currentDevice.deviceCompanyName,
                운영자사업자번호: currentDevice.deviceRegistrationNo,
                '냉장고 ID': currentDevice.deviceID,
                '냉장고 이름': currentDevice.deviceName,
                '트레이 ID': t.trayID,
                '트레이 이름': t.trayName,
                '상품 ID': it.productID,
                '상품 이름': it.productName,
                '판매 개수': it.saleCount,
                '판매 금액': it.saleTotal,
                '판매 이익': it.saleProfit || 0,
                '페기 개수': it.discardCount,
                '페기 금액': it.discardTotal,
                '기타 손실': it.etcLoss,
                '기타 수익': it.etcProfit,
                '영업 이익': it.profit,
                취소: it.cancelTotal,
                재결제: it.rebillTotal,
                환불: it.refundTotal,
                미결제손실: it.nonpaymentTotal,
                미결제후결제: it.nonpaymentBillTotal,
                '-정정': it.correctRemoveTotal,
                '+정정': it.correctAddTotal,
                '+정정(에러)': it.correctAddSoldErrorTotal,
              };
              saleList.push(c);

              saleCount += it.saleCount;
              saleTotal += it.saleTotal;
              saleProfit += it.saleProfit || 0;
              etcLoss += etcLoss;
              etcProfit += etcProfit;
              profit += profit;
              discardCount += it.discardCount;
              discardTotal += it.discardTotal;
              correctRemoveTotal += it.correctRemoveTotal;
              correctAddTotal += it.correctAddTotal;
              correctAddSoldErrorTotal += it.correctAddSoldErrorTotal;
              cancelTotal += it.cancelTotal;
              rebillTotal += it.rebillTotal;
              refundTotal += it.refundTotal;
              nonpaymentTotal += it.nonpaymentTotal;
              nonpaymentBillTotal += it.nonpaymentBillTotal;
            } else {
              saleList.push({
                사업자명: currentDevice.companyName,
                사업자번호: currentDevice.registrationNo,
                운영자명: currentDevice.deviceCompanyName,
                운영자사업자번호: currentDevice.deviceRegistrationNo,
                '냉장고 ID': currentDevice.deviceID,
                '냉장고 이름': currentDevice.deviceName,
                '트레이 ID': t.trayID,
                '트레이 이름': t.trayName,
                '상품 ID': '',
                '상품 이름': '',
                '판매 개수': 0,
                '판매 금액': 0,
                '판매 이익': 0,
                '페기 개수': 0,
                '페기 금액': 0,
                '기타 손실': 0,
                '기타 수익': 0,
                '영업 이익': 0,
                취소: 0,
                재결제: 0,
                환불: 0,
                미결제손실: 0,
                미결제후결제: 0,
                '-정정': 0,
                '+정정': 0,
                '+정정(에러)': 0,
              });
            }
          }

          saleList.push({
            사업자명: currentDevice.companyName,
            사업자번호: currentDevice.registrationNo,
            운영자명: currentDevice.deviceCompanyName,
            운영자사업자번호: currentDevice.deviceRegistrationNo,
            '냉장고 ID': currentDevice.deviceID,
            '냉장고 이름': currentDevice.deviceName,
            '트레이 ID': '전체',
            '트레이 이름': '전체',
            '상품 ID': '전체',
            '상품 이름': '전체',
            '판매 개수': saleCount,
            '판매 금액': saleTotal,
            '판매 이익': saleProfit,
            '페기 개수': discardCount,
            '페기 금액': discardTotal,
            '기타 손실': etcLoss,
            '기타 수익': etcProfit,
            '영업 이익': profit,
            취소: cancelTotal,
            재결제: rebillTotal,
            환불: refundTotal,
            미결제손실: nonpaymentTotal,
            미결제후결제: nonpaymentBillTotal,
            '-정정': correctRemoveTotal,
            '+정정': correctAddTotal,
            '+정정(에러)': correctAddSoldErrorTotal,
          });
        }
      } catch (e) {
        console.error(e);
      }

      return saleList;
    },
    async getCompanyData(value, n) {
      try {
        let companyID = null;

        if (n === 1) {
          companyID = value.companyID;
        } else {
          companyID = value.deviceCompanyID;
        }

        if (!companyID) {
          return;
        }

        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/company/${companyID}?withDivisions=false`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          if (n === 1) {
            value.registrationNo = response.data.company.registrationNo;
            value.companyName = response.data.company.companyName;
          } else {
            value.deviceCompanyName = response.data.company.companyName;
            value.deviceRegistrationNo = response.data.company.registrationNo;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    goPrev() {
      if (this.pagination.page <= 1) {
        return;
      }
      this.pagination.page--;

      this.getTotalList(false);
    },
    goNext() {
      if (this.pagination.page >= this.pagination.length) {
        return;
      }
      this.pagination.page++;

      this.getTotalList(false);
    },
    jumpPrev() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[0];
        this.pagination.page--;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page < 1) {
        this.pagination.page = 1;
      }

      this.getTotalList(false);
    },
    jumpNext() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[
          this.pagination.pageArray.length - 1
        ];
        this.pagination.page++;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page > this.pagination.length) {
        this.pagination.page = this.pagination.length;
      }

      this.getTotalList(false);
    },
    goPage(page) {
      if (page < 1) {
        page = 1;
      }
      if (page > this.pagination.length) {
        page = this.pagination.length;
      }
      this.pagination.page = page;
      this.getTotalList(false);
    },
    async getSum() {
      try {
        const perPage = this.pagination.perPage;
        const page = this.pagination.page;
        const input = this.pagination.input;
        const total = this.pagination.total;
        const length = this.pagination.length;

        const sum = {
          saleCount: 0,
          saleTotal: 0,
          saleProfit: 0,
          discardCount: 0,
          discardTotal: 0,
          etcLoss: 0,
          etcProfit: 0,
          profit: 0,
          //
          cancelTotal: 0,
          rebillTotal: 0,
          refundTotal: 0,
          nonpaymentTotal: 0,
          nonpaymentBillTotal: 0,
          //
          correctRemoveTotal: 0,
          correctAddTotal: 0,
          correctAddSoldErrorTotal: 0,
        };

        this.pagination.perPage = 500;
        for (this.pagination.page = 1; this.pagination.page < 500; this.pagination.page++) {
          const list = await this.getTotalList(true);
          if (!list || list.length === 0) {
            break;
          }
          for (let j = 0; j < list.length; j++) {
            const it = list[j];
            sum.saleCount += it.saleCount;
            sum.saleTotal += it.saleTotal;
            sum.saleProfit += it.saleProfit;
            sum.discardCount += it.discardCount;
            sum.discardTotal += it.discardTotal;
            sum.etcLoss += it.etcLoss;
            sum.etcProfit += it.etcProfit;
            sum.profit += it.profit;
            //
            sum.cancelTotal += it.cancelTotal;
            sum.rebillTotal += it.rebillTotal;
            sum.refundTotal += it.refundTotal;
            sum.nonpaymentTotal += it.nonpaymentTotal;
            sum.nonpaymentBillTotal += it.nonpaymentBillTotal;
            //
            sum.correctRemoveTotal += it.correctRemoveTotal;
            sum.correctAddTotal += it.correctAddTotal;
            sum.correctAddSoldErrorTotal += it.correctAddSoldErrorTotal;
          }
        }
        this.pagination.perPage = perPage;
        this.pagination.page = page;
        this.pagination.input = input;
        this.pagination.total = total;
        this.pagination.length = length;
        //
        this.sum = sum;
      } catch (e) {
        console.error('getSum error', e);
      }
    },
    async downloadExcel() {
      try {
        if (this.downloading) return;

        this.downloading = true;
        const perPage = this.pagination.perPage;
        const page = this.pagination.page;
        const input = this.pagination.input;
        const total = this.pagination.total;
        const length = this.pagination.length;

        const devices = [];
        this.pagination.perPage = 500;
        for (this.pagination.page = 1; this.pagination.page < 500; this.pagination.page++) {
          const list = await this.getTotalList(true);
          if (!list || list.length === 0) {
            break;
          }
          for (let j = 0; j < list.length; j++) {
            const it = list[j];
            const c = {
              사업자번호: it.registrationNo,
              회사이름: it.companyName,
              '냉장고 ID': it.deviceID,
              '냉장고 이름': it.deviceName,
              '판매 개수': it.saleCount,
              '판매 금액': it.saleTotal,
              '판매 이익': it.saleProfit,
              '페기 개수': it.discardCount,
              '페기 금액': it.discardTotal,
              '기타 손실': it.etcLoss,
              '기타 수익': it.etcProfit,
              '영업 이익': it.profit,
              //
              취소: it.cancelTotal,
              재결제: it.rebillTotal,
              환불: it.refundTotal,
              미결제손실: it.nonpaymentTotal,
              미결제후결제: it.nonpaymentBillTotal,
              //
              //
              '-정정': it.correctRemoveTotal,
              '+정정': it.correctAddTotal,
              '+정정(에러)': it.correctAddSoldErrorTotal,
            };
            devices.push(c);
          }
        }
        this.pagination.perPage = perPage;
        this.pagination.page = page;
        this.pagination.input = input;
        this.pagination.total = total;
        this.pagination.length = length;

        if (devices.length === 0) {
          alert('다운로드할 내용이 없습니다.');
          this.downloading = false;
          return;
        }

        js2excel.json2excel({
          data: devices,
          name: 'cella-device',
          formateDate: 'yyyy/mm/dd',
        });
      } catch (e) {
        console.error('downloadExcel error', e);
      }

      this.downloading = false;
      /*
      // for webpack 3: dynamic import
      // webpackChunkName: "js2excel"
      import('js2excel').then(({ json2excel }) => {
        json2excel({
          data: this.list,
          name: this.downloadFileName,
          formateDate: 'dd/mm/yyyy',
        });
      }).catch((e) => {

      });
      */
    },
    async downloadAllExcel() {
      let count = 0;

      try {
        if (this.downloading) return count;

        this.downloading = true;
        const totalList = [];
        const devices = await this.getDeviceList();

        for (let i = 0; i < devices.length; i++) {
          const saleList = await this.getListForExcel(devices[i].deviceID);
          Array.prototype.push.apply(totalList, saleList);
        }

        if (totalList.length === 0) {
          alert('다운로드할 내용이 없습니다.');
          this.downloading = false;
          return count;
        }

        js2excel.json2excel({
          data: totalList,
          name: 'cella-sale-all',
          formateDate: 'yyyy/mm/dd',
        });
        count = totalList.length;
      } catch (e) {
        console.error(e);
        count = 0;
      }

      this.downloading = false;

      return count;
    },
    async getDeviceList() {
      let deviceList = [];

      try {
        let getURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/list?page=1&limit=500`;

        //
        if (this.scope !== 1 && this.scope !== 2) {
          getURL += `&companyID=${this.company.id}`;
        }

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });

        if (result.status === 200 && result.data.resultCode === '0000') {
          deviceList = result.data.devices;
        }
      } catch (e) {
        deviceList = [];
        console.error(e);
      }

      return deviceList;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sale/DeviceList.vue